import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

/** Uma empresa do grupo. As faturas pertencem a uma delas, pelo NIF que consta do documento. */
export interface Company {
  id: number;
  name: string;
  taxId: string;
  /** Empresa assumida quando o documento importado não identifica nenhuma. */
  isDefault: boolean;
  sortOrder: number;
  /** Nº de faturas lançadas — com lançamentos, a empresa não pode ser eliminada. */
  financialEntriesCount: number;
}

export interface CompanyPayload {
  name: string;
  taxId: string;
  isDefault?: boolean;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}

export function getCompanies(): Promise<Company[]> {
  return request<Company[]>("/api/companies");
}

export function createCompany(payload: CompanyPayload): Promise<Company> {
  return request<Company>("/api/companies", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function updateCompany(
  id: number,
  payload: CompanyPayload,
): Promise<Company> {
  return request<Company>(`/api/companies/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function deleteCompany(id: number): Promise<void> {
  return request<void>(`/api/companies/${id}`, { method: "DELETE" });
}
